module.exports = __webpack_public_path__ + "static/smartgrader-43c86a20fc65f85d7142cf60f5a3e9e6.png";